<template>
	<div>
		<h3>渠道管理</h3>
		<el-button type="primary" size="small" @click="centerDialogVisible=true;title='添加渠道';ruleForm2={name: ''}">添加渠道</el-button>
		<div class="table">
			<el-table :data="tableData4" style="width: 100%" height='calc(100vh - 300px)' border>
				<el-table-column prop="name" label="渠道名称"></el-table-column>
				<el-table-column prop="id" label="渠道ID"></el-table-column>
				<el-table-column label="操作" align='center'>
					<template slot-scope="scope">
						<template v-if="scope.row.sourceBy == 1">
							<el-button type="text" @click="centerDialogVisible=true;ruleForm2=scope.row;title='修改渠道'">修改渠道</el-button>
							<el-button type="text" @click="centerDialogVisible1=true;ruleForm2=scope.row;">删除渠道</el-button>
						</template>
						<template v-else>
							<el-button type="text" disabled>修改渠道</el-button>
							<el-button type="text" disabled>删除渠道</el-button>
						</template>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="fenye">
			<el-pagination class='pagination' @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 30, 40]"
			 :page-size="10" layout="total, sizes, prev, pager, next, jumper" :total="allpage">
			</el-pagination>
		</div>
		<!-- //添加员工 -->
		<el-dialog :title="title" :visible.sync="centerDialogVisible" center>
			<el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
				<el-form-item label="渠道名称:" prop="name">
					<el-input v-model="ruleForm2.name" autocomplete="off" placeholder='请输入渠道名称'></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false;getData()">取 消</el-button>
				<el-button type="primary" @click="submitForm('ruleForm2')">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="删除渠道" :visible.sync="centerDialogVisible1" width='400px'  center>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible1 = false">取 消</el-button>
				<el-button type="primary" @click="deleteFun('ruleForm2')">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { addchannel,listchannelBySetter,delchannel } from '@/axios/api.js'
	export default {
		data() {
			var checkAge = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('请输入渠道名称！'));
				} else {
					callback();
				}
			};
			return {
				ruleForm2: {
					name: ''
				},
				title:'添加渠道',
				ruleForm3: {
					value1: true,
					value2: true,
					value3: true,
					value4: true,
				},
				rules2: {
					name: [{
						validator: checkAge,
						trigger: 'blur'
					}]
				},
				formInline: {
					user: '',
					region: '',
					time: ''
				},
				tableData: [],
				tableData4: [],
				centerDialogVisible: false,
				centerDialogVisible1: false,
				allpage:0,//数据总数
				eachPage:10,//每页
				indexPage:1,//当前页				
			}
		},
		methods: {
			handleSizeChange(val) { //console.log(`每页 ${val} 条`);
				this.eachPage = val;
				this.tableData4 = this.tableData.slice(0, this.eachPage);
			},
			handleCurrentChange(val) { //console.log(`当前页: ${val}`);
				this.indexPage = val;
				this.tableData4 = this.tableData.slice(this.eachPage * (this.indexPage - 1), this.eachPage * this.indexPage);
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
				console.log(val)
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.addChannelFun()	
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			addChannelFun(){
				var data={}
				if(this.title == '添加渠道'){
					data={
						name:this.ruleForm2.name,
						channelId:JSON.parse(window.localStorage.getItem("token")).data.obj2.channelId
					}					
				}else{
					data={
						name:this.ruleForm2.name,
						channelId:JSON.parse(window.localStorage.getItem("token")).data.obj2.channelId,
						id:this.ruleForm2.id
					}	
				}

				addchannel(data)
				.then( res => {
					console.log(res)
					if(res.data.code == 0){
						var message=''
						if(this.title == '添加渠道'){
							message='恭喜你，添加渠道成功！'
						}else{
							message='恭喜你，修改渠道成功！'
						}
						this.$message({
						  showClose: true,
						  message,
						  type: 'success'
						});
						this.centerDialogVisible=false;
						this.getData()
					}
				})
				.catch(err => {
					console.log(err)
				})
			},
			getData(){
				var data={
					start:0,
					count:500
				}
				listchannelBySetter(data)
				.then( res => {
					if(res.data.code == 0){
						this.tableData=res.data.obj.reverse()
						this.allpage=this.tableData.length;
						this.handleSizeChange(this.eachPage);
					}
				})
				.catch(err => {
					console.log(err)
				})
			},
			deleteFun(){
				var data={
					id:this.ruleForm2.id
				}
				delchannel(data)
				.then( res => {
					if(res.data.code == 0){
						this.$message({
						  showClose: true,
						  message:'删除成功！',
						  type: 'success'
						});
						this.centerDialogVisible1=false;
						this.getData()
					}
				})
				.catch(err => {
					console.log(err)
				})				
			}
		},
		mounted() {
			this.getData()
		}
	}
</script>
<style>
	.has-gutter th {
		background-color: #f5f7fb;
	}
</style>
<style scoped="scoped">
	h3 {
		margin: 20px 0;
		font-weight: normal;
	}

	.searchBox {
		margin-top: 20px;
	}

	.table {
		margin-top: 20px;
	}

	.fenye {
		margin-top: 20px;
		overflow: hidden;
	}

	.fenye .pagination {
		float: right;
	}
</style>



// WEBPACK FOOTER //
// src/views/setting/channelSetting.vue